// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// CareRx wave-1 #2: the document tracker's clickable tiles. The tracker is SERVER-paged, so a tile
// filters by sending ?tile=key (DocTile in CareRxConsentEsignFunctions), ANDed with the header funnels.
//
// Every tile counts PLANS (rows), and its click lists exactly those plans:
//   · Drafts / Ready to send / Awaiting signature — at least one of the three lanes in that state
//     (draft | ready_to_send | sent).
//   · Fully signed — all three lanes Signed (fully_signed).
//   · Plans of Treatment — the cleared state.
// The server counts the tiles over the funnel-filtered set WITHOUT the tile filter, so a click never
// reshuffles the other tiles; `summary.plans` is that set's size (the list total follows the tile).

export type DocTileKey = 'draft' | 'ready_to_send' | 'sent' | 'fully_signed'

/** The tracker request's filter part (funnels unchanged, the tile as its own parameter) and a stable signature. */
export function docTrackerRequest(funnels: readonly string[], tile: DocTileKey | null): { filter: string[]; tile?: DocTileKey; sig: string } {
  const filter = [...funnels].sort()
  return { filter, tile: tile ?? undefined, sig: filter.join('|') + (tile ? `|tile:${tile}` : '') }
}

/** Clicking the active tile clears it; `null` (the total tile) always clears. */
export const nextDocTile = (current: DocTileKey | null, clicked: DocTileKey | null): DocTileKey | null =>
  clicked === null || current === clicked ? null : clicked
